import axios from "axios";
import qs from "qs";
import port from "@/server/port.js";
import store from "@/store/index.js";
import { Message, Modal } from "iview";
// import router from '@/router/index.js';

axios.defaults.withCredentials = true; // 携带cookie
axios.defaults.timeout = 20000; //请求超时时间
axios.defaults.retry = 2; //超时重新请求次数

// 添加请求拦截器
axios.interceptors.request.use(
  (config) => {
    // 设置post数据格式
    if (config.stringify) {
      config.data = qs.stringify(config.data);
    }
    // 打开loading
    if (!config.cancelLoading) store.dispatch("openLoading");
    return config;
  },
  (error) => Promise.reject(error)
);

// 添加响应拦截器
axios.interceptors.response.use(
  (res) => {
    // 关闭loading
    store.dispatch("closeLoading");
    return res.data;
  },
  (error) => {
    store.dispatch("closeLoading");
    const config = error.config;
    const request = error.request;

    //  如果状态码为401，则跳转到登陆页面
    if (request.status === 401) {
      window.location.href = port.login;
    }

    //没有设置重新请求和不是超时的话则返回
    if (!config || !config.retry || !error.message.includes("timeout")) {
      setTimeout(
        () => Modal.error({ title: "请求出错", content: error.message }),
        300
      );
      return Promise.reject(error);
    }

    //记录重新请求次数
    config.retryCount = config.retryCount || 0;
    //超过次数
    if (config.retryCount >= config.retry) {
      setTimeout(
        () =>
          Modal.error({ title: "请求出错", content: "请求超时！请刷新重试！" }),
        300
      );
      return Promise.reject(error);
    }

    Message.error({ content: "请求超时！重试中，请稍等！", duration: 3 });
    config.retryCount += 1;
    //重新请求
    return axios(config);
  }
);

/*
 * @description常规回调处理
 * @param res:object 回调对象
 */
axios.commonCallback = (res, successMsg) => {
  if (res.status == 200) {
    Message.success({
      content: successMsg ? successMsg : res.message,
      duration: 1.5,
    });
  } else {
    Message.error({
      content: res.message,
      duration: 1.5,
    });
  }
};

export default axios;



// WEBPACK FOOTER //
// ./src/server/axios.js